<div ngModelGroup="comboRaca-{{data}}" fxFlex="100" fxLayoutGap="20px">
    <combo-pesquisavel #comboRaca
                       nome="raca-{{data}}"
                       [itens]="dados"
                       itemDescricao="tipo"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Raça/Cor"
                       label="Raça/Cor"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
